export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00508.15998dcb.png";